import React from "react";
import {Helmet} from "react-helmet";

class PageTitle extends React.Component {

  	render() {
		return (
			<div className="Page_Title">
	            <Helmet>
			        <title>Digital Marketing Service | Digipanda</title>
			        <meta name="description" content="Digital Marketing Service" />
			    </Helmet>
			</div>
		);
	}
};

export default PageTitle;
